import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Translates technical role names to user-friendly Spanish names
 */
export function getRoleDisplayName(role: string, displayName?: string): string {
  if (displayName) return displayName
  // Fallback for cases where display_name is not available
  return role
}

/**
 * Muestra un importe en formato argentino: $ 1.234,56 — separador de miles con punto,
 * decimales con coma y siempre dos decimales.
 *
 * Es el único lugar donde se le da formato a la plata. Las pantallas que armaban el
 * número a mano (`$` + `toFixed(2)`) terminaban mostrando 1456.78, que es el formato
 * de EEUU.
 *
 * `currency` es el ISO de tres letras que guarda el módulo de compras; cualquier otra
 * cosa cae en pesos en vez de romper la pantalla.
 */
export function formatCurrency(amount: number | string, currency = 'ARS'): string {
  const iso = /^[A-Za-z]{3}$/.test(String(currency)) ? String(currency).toUpperCase() : 'ARS'
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: iso,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0)
}
